import { useInventoryUiStore } from './useInventoryUiStore';

export {
  useInventoryUiStore,
  type InventoryEntrySuggestion,
} from './useInventoryUiStore';

export function resetAllInventorySlices() {
  useInventoryUiStore.getState().resetAll();
}

/** Bump stockDataRevision so the Inventory screen reloads its stock list. Call from other modules after stock changes. */
export function notifyStockDataChanged() {
  useInventoryUiStore.getState().bumpStockDataRevision();
}
